import {findContainer, getDataAttributes} from "./_util";
import {Modal} from "../../index.esm";

const VGModal = {
	isAdded: false,
	isInit: false,
	cross: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"' +
		'\t viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">' +
		'<path d="M89.7,10.3L89.7,10.3c-1-1-2.6-1-3.5,0L50,46.5L13.9,10.3c-1-1-2.6-1-3.5,0l0,0c-1,1-1,2.6,0,3.5L46.5,50L10.3,86.1' +
		'\tc-1,1-1,2.6,0,3.5h0c1,1,2.6,1,3.5,0L50,53.5l36.1,36.1c1,1,2.6,1,3.5,0l0,0c1-1,1-2.6,0-3.5L53.5,50l36.1-36.1' +
		'\tC90.6,12.9,90.6,11.3,89.7,10.3z"/>' +
		'</svg>',
	yaMap: {
		mark:  {
			preset: 'islands#icon',
			iconColor: '#ff3819'
		}
	},

	init: function (modal, arg = {}) {
		if (!modal) {
			VGLog("error", ["Товарищ! Первый параметр не должен быть пустым!"]);
			return false;
		}

		let params = {
			type: 'bootstrap',
			cloned_content: 'false'
		}, dataParams = {};

		if (typeof modal === 'string') {
			params.modal = findContainer(modal);
			if (params.modal) dataParams = getDataAttributes(params.modal);
		} else if (typeof modal === 'object') {
			let target = modal.dataset.target || modal.getAttribute('href') || null;

			if (!target) {
				VGLog("error", ["Мон Синьор! Путь к модалке не найден"]);
				return false;
			}
			params.modal = findContainer(target);
			dataParams = getDataAttributes(modal);
		} else {
			VGLog("error", ["КЭП! Какая-то дичь к нам залетела"]);
			return false;
		}

		if (!params.modal) {
			VGLog("error", ["Сударь! А где, собственно, модалка?"]);
			return false;
		}

		params = Object.assign({}, dataParams, params, arg);

		VGModal.isInit = true;
		VGModal.run(params);
	},

	run: function (params) {
		if (!VGModal.isInit) return false;

		let $modal = params.modal,
			$type = params.type,
			$cloned_content = params.cloned_content;

		let dParams = ['modal', 'type', 'cloned_content', 'data-vg-toggle'];
		dParams.forEach(function (value) {
			delete params[value];
		});

		for (let key in params) {
			let value = params[key];

			if (!VGModal.isAdded) {
				let $elements = $modal.querySelectorAll('[' + key + ']');
				for (let $tag of $elements) {
					if ($tag.tagName === 'INPUT' || $tag.tagName === 'TEXTAREA') {
						$tag.value = value;
					} else if ($tag.tagName === 'IMG') {
						$tag.setAttribute('src', value);
					} else if (key === 'data-action') {
						$tag.setAttribute('action', value);
					} else {
						$tag.textContent = value;
					}
				}
			}

			if (key === 'data-map') {
				VGModal.map('yaMap', value.split(','));
			}

			if(key === 'data-is-added') {
				VGModal.isAdded = true;
			}
		}

		if ($type === 'bootstrap') {
			VGModal.modalBootstrap($modal, $type, params);
		} else if ($type === 'fancybox') {
			VGModal.modalFancybox($modal, $type, params);
		}
	},

	modalBootstrap: function ($modal, $type, params) {
		if (!VGModal.isInit) return false;

		let $modalBtnClose = $modal.querySelector('.modal-close-block');
		if (!$modalBtnClose) {
			let div = document.createElement('div');
			div.className = "modal-close-block";

			let $content = $modal.querySelector('.modal-content');
			div.innerHTML = '<button type="button" class="modal-close white" data-bs-dismiss="modal" aria-label="Close">' + VGModal.cross + '</button>';
			$content.prepend(div);
		} else {
			$modalBtnClose.innerHTML = '<button type="button" class="modal-close white" data-bs-dismiss="modal" aria-label="Close">' + VGModal.cross + '</button>';
		}

		let modal = new Modal($modal, params);
		modal.show();

		let $search = $($modal).find('#catalog-search--input');
		if ($search.length) {
			setTimeout(function() { $search.focus() }, 500);
		}

		if ('data-reload' in params) {
			$modal.addEventListener('hidden.bs.modal', event => {
				location.reload();
			});
		}

		if ('data-route' in params && 'data-content' in params) {
			let $target = $(params['data-content']),
				route = params['data-route']
			;

			let deleteParams = [
				'cloned_container',
				'data-content',
				'data-modal',
				'data-route',
				'data-target',
				'data-type',
			];

			for (let p in deleteParams)
				delete params[deleteParams[p]];

			$($modal).find('.modal-preload').show();

			$.get(route, params, function (data) {
				setTimeout(() => {
					$($modal).find('.modal-preload').fadeOut();
					$target.html(data.view);
					$target.closest('.modal').trigger('modal-loaded');

					let $swiper = $target.find('.swiper');
					if($swiper.length) {
						$swiper.each(function () {
							VGCarousel.init(this);
						});
					}

					let $form = $target.find('[data-vgformsender]');
					if($form.length) {
						$form.vegasFormSender({
							beforeSend: function (form, params) {
								AlertFormSender.Action.beforeSend(form, params);
							},
							success: function (data, form, params) {
								if (data.error) {
									AlertFormSender.Action.error(data.msg, form, params);
								} else {
									AlertFormSender.Action.success(data.msg, form, params);
								}
							},
							error: function (msg, form, params) {
								AlertFormSender.Action.error(msg, form, params);
							},
							validate: function (form, params, errors) {
								ValidateFormSender.init(errors, form, params);
							}
						});
					}

				}, 1000);

				return false;
			});
		}
	},

	modalFancybox: function ($modal, $type, params) {
		if (!VGModal.isInit) return false;

		let $modalBtnClose = $modal.querySelector('.modal-close-block');
		if (!$modalBtnClose) {
			let div = document.createElement('div');
			div.className = "modal-close-block";
			div.innerHTML = '<button type="button" data-fancybox-close class="modal-fbx-close white" title="CLOSE" aria-label="Close">' + VGModal.cross + '</button>';
			$modal.prepend(div);
		} else {
			$modalBtnClose.innerHTML = '<button type="button" data-fancybox-close class="modal-fbx-close white" title="CLOSE" aria-label="Close">' + VGModal.cross + '</button>';
		}

		params.src = '#' + $modal.id;
		params.type = 'inline';
		params.closeButton = false;

		fbx.Fancybox.show([params]);
	},

	map: function (id, coordinate) {
		let $map = document.querySelector('#' + id + ' ymaps');

		if($map) {
			$map.remove();
		}

		let myMap;
		yaMapInit(id);

		function yaMapInit(map_ID) {
			ymaps.ready(init);

			function init() {
				let lat = coordinate[0];
				let lon = coordinate[1];

				myMap = new ymaps.Map(map_ID, {
					center: [lat, lon],
					zoom: 16
				}, {
					searchControlProvider: 'yandex#search',
					suppressMapOpenBlock: true,
				});

				myMap.controls.remove('typeSelector');
				myMap.controls.remove('fullscreenControl');
				myMap.controls.remove('trafficControl');
				myMap.controls.remove('searchControl');

				myMap.geoObjects
				.add(new ymaps.Placemark([lat, lon], {
					balloonContent: ''
				}, VGModal.yaMap.mark));

				if (window.innerWidth < 1000) {
					myMap.behaviors.get('drag').disable();
				}

				myMap.behaviors.disable('scrollZoom');
			}

			return false;
		}
	}
};

function onReady() {
	let $btnModal = document.querySelectorAll('[data-vg-toggle="modal"]');
	if ($btnModal.length) {
		for (let $btn of $btnModal) {
			$btn.onclick = function () {
				VGModal.init(this);
				return false;
			};
		}
	}
}

document.addEventListener("DOMContentLoaded", onReady);

export default VGModal;
